import { type FC, useEffect, useRef, useState } from 'react';
import { clsx } from 'clsx';

import { getAnimationDuration } from './helpers';

import styles from './Ticker.css';

export type TickerTheme = 'dark' | 'light' | 'dark-background';

export interface ITickerProps {
  /** Текст бегущей строки */
  text: string;
  /** Тема оформления */
  theme: TickerTheme;
  /** Убрать padding слева */
  withoutPadding?: boolean;
  /** Останавливать анимацию при наведении курсора */
  pauseOnHover?: boolean;
}

/** Бегущая строка */
export const Ticker: FC<ITickerProps> = ({ text, theme, withoutPadding, pauseOnHover }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const tickerRef = useRef<HTMLDivElement>(null);
  const [animationDuration, setAnimationDuration] = useState(0);
  const [isInfinite, setInfinite] = useState<boolean>(false);
  const [isStatic, setStatic] = useState<boolean>(false);

  useEffect(() => {
    const time = getAnimationDuration(tickerRef.current, wrapperRef.current);

    if (!time) {
      setStatic(true);
    } else {
      setStatic(false);
      setAnimationDuration(time);
    }
  }, [text, isInfinite]);

  const hanldeAnimationEnd = (): void => setInfinite(true);

  return (
    <div
      className={clsx(
        styles['container'],
        isStatic && styles['container--static'],
        isInfinite && styles['container--infinite'],
        styles[`container--${theme}`],
        withoutPadding && styles['container--without-padding'],
        pauseOnHover && styles['container--pause-hover'],
      )}
      ref={wrapperRef}
    >
      <div
        className={styles['ticker']}
        ref={tickerRef}
        style={{ WebkitAnimationDuration: `${animationDuration}s`, animationDuration: `${animationDuration}s` }}
        onAnimationEnd={hanldeAnimationEnd}
      >
        <div className={styles['text']}>{text}</div>
      </div>
    </div>
  );
};
